import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import TopicRules from './TopicRules';
import { topicSettings } from '../state/topicSettings';
import { hotTopics, orderedHotTopics } from '../state/hotTopics';
/**
 * The column beside the posts.
 *
 * Three blocks, the way the design draws them:
 *
 * - 正在热的话题 — the topics that are rising fastest, one flame each;
 * - 热门话题 — the hottest topics, with their full level;
 * - 话题规则 — the rules a poster has to know.
 *
 * The topics come from the shared hot list, so this costs no request of its
 * own.
 */
export default class TopicAside extends Component {
  /** The hot topics, in the order they should be shown. */
  topics = [];
  loading = true;
  oninit(vnode) {
    super.oninit(vnode);
    this.load();
  }
  async load() {
    const settings = await topicSettings();
    try {
      const list = await hotTopics();
      this.topics = orderedHotTopics(list, settings.hotCurated, settings.hotLimit);
    } catch {
      this.topics = [];
    }
    this.loading = false;
    m.redraw();
  }
  view(vnode) {
    if (this.loading) return null;
    return m("div", {
      className: 'TopicAside' + (this.attrs.className ? ' ' + this.attrs.className : '')
    }, this.risingBlock(), this.hotBlock(), m(TopicRules, null));
  }

  /**
   * 正在热的话题 — the five topics that are rising fastest.
   *
   * A topic without a trend (nothing to compare against yet) is left out.
   *
   * The list is the names only: the block's own title says the list is
   * ranked by momentum, and the order inside it is that momentum. A flame
   * beside every name would say the same thing five times over.
   */
  risingBlock() {
    const rising = this.topics.filter(topic => topic.heatTrend() !== null && topic.heatTrend() !== undefined).sort((a, b) => (b.heatTrend() ?? 0) - (a.heatTrend() ?? 0)).slice(0, 5);
    if (!rising.length) return null;
    return m("div", {
      className: "TopicAside-block"
    }, m("h2", {
      className: "TopicAside-title"
    }, app.translator.trans('ziiven-topics.forum.hot.rising_title')), m("div", {
      className: "TopicAside-list"
    }, rising.map(topic => m("div", {
      className: "TopicAside-row",
      key: topic.id()
    }, m(Link, {
      className: "taglink TopicAside-name",
      href: app.route('topic', {
        name: topic.nameKey()
      })
    }, "#", topic.name())))));
  }

  /**
   * 热门话题 — the hottest topics.
   *
   * The names only, for the same reason as the block above: the title says
   * the list is ranked by heat, and the order inside it is that heat.
   */
  hotBlock() {
    if (!this.topics.length) return null;
    return m("div", {
      className: "TopicAside-block"
    }, m("h2", {
      className: "TopicAside-title"
    }, app.translator.trans('ziiven-topics.forum.hot.side_title')), m("div", {
      className: "TopicAside-list"
    }, this.topics.map(topic => m("div", {
      className: "TopicAside-row",
      key: topic.id()
    }, m(Link, {
      className: "taglink TopicAside-name",
      href: app.route('topic', {
        name: topic.nameKey()
      })
    }, "#", topic.name())))));
  }
}
flarum.reg.add('ziiven-topics', 'forum/components/TopicAside', TopicAside);